import styled from 'styled-components/macro'
import Tooltip from 'components/Tooltip/Tooltip'

export const StyledTooltip = styled(Tooltip)<{ right?: string }>`
  position: absolute;
  right: ${(props) => props.right || '1rem'};
  font-size: 1.3rem;
`
